import React, { useState, useEffect, useCallback } from 'react'
import { useSnackbar } from 'notistack'
import DynamicTable from '../../components/DataTables/DynamicTable'
import SeguridadesLogic from '../../functions/logic/Seguridades'
import FormModal from '../../components/General/FormModal'
import Spiner from '../../components/General/Spiner'
import { styled } from '@mui/material/styles'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const Roles = () => {
  const [spiner, setSpiner] = useState(false)
  const [isOpenModalform, setIsOpenModalForm] = useState(false)
  const [dataTableroForm, setDataTableroForm] = useState([])
  const { enqueueSnackbar } = useSnackbar()
  const [saveType, setSaveType] = useState('I')
  const [header, setHeader] = useState('I')
  const userToken = localStorage.getItem('token')
  const [rolId, setRolId] = useState(0)
  const [data, setdata] = useState([])
  const [dataRol, setdataRol] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const getRoles = useCallback(async (page, perPage, search = "") => {
    setSpiner(true)
    const resp = await SeguridadesLogic.rolesLogic(page, perPage, search)
    if (resp.success) {
      setdata(resp.data)
      setTotalRows(resp.totalRows)
    }
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setSpiner(false)
    cleanStorage()
  }, [enqueueSnackbar])

  useEffect(() => {
    getRoles(1, 10)
  }, [getRoles])


  const columns = ['Codigo', 'Nombre', 'Descripcion', 'Fecha'] // Ajusta esto según tus necesidades

  // Funciones para manejar las acciones de los botones
  const handleNew = async () => {
    cleanStorage()
    setSaveType("I")
    setRolId(0)
    setSpiner(true)
    setDataTableroForm([])
    setIsOpenModalForm(true)
    setSpiner(false)
    setHeader('Nuevo Rol')
  }

  const cleanStorage = () => {
    localStorage.removeItem('codigoRol')
    localStorage.removeItem('nombreRol')
    localStorage.removeItem('descripcionRol')
  }

  const handleCloseModal = () => {
    setIsOpenModalForm(false)
    cleanStorage()
  }

  const handledSave = async (event) => {
    event.preventDefault()
    const retrievedData = JSON.parse(localStorage.getItem("rolData"));
    console.log(retrievedData)
    console.log(userToken)
    console.log(rolId)
  }

  const handleEdit = (item) => {
    cleanStorage()
    setSaveType("E")
    setdataRol(item)
    setRolId(item.id)
    setSpiner(true)
    setDataTableroForm(item)
    setIsOpenModalForm(true)
    setSpiner(false)
    setHeader('Editar Rol')
  }

  const handleDelete = (item) => {
    setSelectedItem(item)
    setOpenDeleteModal(true)
  }

  const confirmDelete = async () => {
    if (selectedItem) {
      setSpiner(true)
      const payload = {
        status: "edit",
        codigoRol: selectedItem.Codigo,
        esActivo: "N",
        usuarioModificacion: localStorage.getItem('userName'),
    }
      const resp = await SeguridadesLogic.saveEditRolesLogic(payload)
      enqueueSnackbar(resp.message, {
        variant: resp.variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      })
      if (resp.success) {
        window.location.reload()
      }
      setSpiner(false)
      setOpenDeleteModal(false)
    }
  }

  const cancelDelete = () => {
    setOpenDeleteModal(false)
  }

  const handlePageChange = (page, perPage) => {
    getRoles(page, perPage, '')
  }

  const handleSearch = (item) => {
    getRoles(1, 100, item)
    // Lógica para eliminar el elemento
  }

  const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '20px',
    marginLeft: theme.spacing(4),
    padding: theme.spacing(1, 4),
  }))

  return (
    <div className="content-wrapper">
      <Spiner opt={spiner} />
      <FormModal
        isOpen={isOpenModalform}
        handleCloseModal={handleCloseModal}
        header={header}
        button={'Guardar'}
        formData={dataTableroForm}
        handledSave={handledSave}
        opt={'rolesBI'}
        modalWith={'md'} // Puedes ajustar a 'xs', 'sm', 'lg', 'xl' según lo que necesites
      />

      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Seguridades</li>
                <li className="breadcrumb-item">roles</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <br />
                <div className="card-body">
                  <DynamicTable
                    columns={columns}
                    data={data}
                    onNew={handleNew}
                    headerText="Nuevo Rol"
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    onSearch={handleSearch}
                    onPageChange={handlePageChange}
                    totalRows={totalRows}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Dialog
        open={openDeleteModal}
        onClose={cancelDelete}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialogContent-root": {
            overflowY: "hidden", // Esto evitará la barra de desplazamiento
          },
          "& .MuiDialog-paper": {
            maxHeight: "400px", // Ajusta el tamaño máximo del modal si es necesario
          },
        }}
      >
        <DialogTitle>
          Confirmar Eliminación
          <IconButton
            edge="end"
            color="inherit"
            onClick={cancelDelete}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <p>¿Estás seguro que deseas eliminar este elemento?</p>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={cancelDelete} sx={{ backgroundColor: 'lightblue', color: 'blue', '&:hover': { backgroundColor: 'lightblue' } }}>
            Cancelar
          </StyledButton>
          <StyledButton onClick={confirmDelete} sx={{ backgroundColor: 'blue', color: 'white', '&:hover': { backgroundColor: 'darkblue' } }}>
            Confirmar
          </StyledButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default Roles
